<script lang="ts" setup>
import { computed } from "vue";

import { getColorByStaffId } from "@/lib/utils";
import { IPractitioner } from "@/types";

const props = withDefaults(
  defineProps<{
    practitioner: IPractitioner;
    size?: 'sm' | 'md'
  }>(),
  {
    size: 'md'
  }
);

const imgStyles = computed(() => {
  let width: string = '2.25rem';
  let fontSize: string = 'var(--font-sm)'

  if (props.size === 'sm') {
    width = '2rem';
    fontSize = 'var(--font-xs)'
  };

  return ({
    width,
    height: width,
    minWidth: width,
    minHeight: width,
    fontSize,
  });
});

const staffNameStyles = computed(() => {
  let fontSize = 'var(--font-base)';

    if (props.size === 'sm') {
    fontSize = 'var(--font-sm)'
  };

  return ({
    fontSize
  });
});

const staffEmailStyles = computed(() => {
  let fontSize = 'var(--font-sm)';

    if (props.size === 'sm') {
    fontSize = 'var(--font-xs)'
  };

  return ({
    fontSize
  });
});
</script>

<template>
  <div class="w-100 d-flex align-items-center">
    <div
      class="img-wrapper d-flex align-items-center justify-content-center"
      :style="{
        background: getColorByStaffId(practitioner?.id),
        ...imgStyles,
      }"
    >
      <span style="letter-spacing: -1px;">
        {{ practitioner?.firstname.charAt(0).toUpperCase() }}
        {{ practitioner?.lastname.charAt(0).toUpperCase() }}
      </span>
    </div>
    <div class="d-flex flex-column">
      <span id="staff-fullname" class="staff-fullname ellipsis-wrapper" :style="{ ...staffNameStyles }">
        {{ practitioner?.firstname + " " + practitioner?.lastname }}
      </span>
      <span id="staff-email" class="staff-email ellipsis-wrapper" :style="{ ...staffEmailStyles }">
        {{ practitioner?.email }}
      </span>
    </div>
  </div>
</template>

<style scoped>
.img-wrapper {
  color: var(--ch-white);
  border-radius: 100%;
  margin-right: var(--font-xs);
}

.staff-fullname {
  max-width: 12rem;
  color: var(--ch-black-80);
  line-height: 100%;
  letter-spacing: -6%;
}

.staff-email {
  max-width: 12rem;
  color: var(--ch-black-40);
  letter-spacing: -3%;
}

.table-container .table-cell-clickable:hover .staff-fullname,
.table-container .table-cell-clickable:focus .staff-fullname {
  color: #FFFFFFCC;
}

.table-container .table-cell-clickable:hover .staff-email,
.table-container .table-cell-clickable:focus .staff-email {
  color: #FFFFFF66;
}
</style>